import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { ProtectAccountDialog as View } from './view'

export const ProtectAccountDialog = {
    View: reflect({
        view: View,
        bind: {
            onFormSubmit: model.formSubmitted,
            formErrorMessage: model.$formErrorMessage,
            onLaterButtonClick: model.laterButtonClicked,
            defaultFormValues: model.$lastFormValues,
            submitButtonDisabled: model.$submitFormButtonDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(ProtectAccountDialog.View))
